import { SegmentationIds } from 'constants/segmentation';

export default {
  'landingpage:foodlines-presenter:usps:no-animal-testing': 'Zonder{br}dierproeven',
  'landingpage:foodlines-presenter:usps:best-quality': 'Beste{br}grondstofkwaliteit',
  'landingpage:foodlines-presenter:usps:high-acceptance': 'bijzonder hoge{br}acceptatie',
  'landingpage:foodlines-presenter:usps:no-grain': 'zonder{br}granen &amp; gluten',
  'landingpage:general:control-variant:discover': 'Ik wil de voeding verbeteren voor',
  'landingpage:general:control-variant:for-dogs': '<span>m</span>ijn hond',
  'landingpage:general:control-variant:for-cats': '<span>m</span>ijn kat',

  'landingpage:value-proposition:header': 'Vers & lekker, direct in de voerbak.',
  'landingpage:value-proposition:header-2': 'Verse ingrediënten. Beste smaak. Persoonlijke keuze.',
  'landingpage:value-proposition:sub-header':
    'Met <strong>"Smaakt niet, bestaat niet."</strong> -garantie.',
  'landingpage:value-proposition:button': 'BESPAAR NU 15%',
  'landingpage:value-proposition:success':
    'Je nieuwe-klant-code wordt automatisch toegepast bij het afrekenen',

  'landingpage:category-slider:title-NC': 'Snuffel zelf rond',
  'landingpage:category-slider:title-EC': 'Onze voedingscategorieën',

  'landingpage:fube-blutte-point-1-dog': 'Beantwoord 10 vragen over je hond',
  'landingpage:fube-blutte-point-1-cat': 'Beantwoord 10 vragen over je kat',
  'landingpage:fube-blutte-point-2': 'Wij vinden de perfecte voeding voor je viervoeter',

  'landingpage:collection-slider:title': ' Wij zijn probleemoplossers',

  'ai-weight-analyzer:entry:label': 'Gewichtsmanagement',
  'ai-weight-analyzer:entry:title': 'Te dun, te dik of precies goed?',
  'ai-weight-analyzer:entry:description:dog':
    "Upload maximaal 3 foto's en ontdek waar je viervoeter op de conditieschaal staat.",
  'ai-weight-analyzer:entry:description:cat':
    "Upload maximaal 3 foto's en ontdek waar je poes op de conditieschaal staat.",
  'ai-weight-analyzer:entry:cta:dog': 'Gewicht analyseren',
  'ai-weight-analyzer:entry:cta:cat': 'Gewicht controleren',
  'ai-weight-analyzer:pet-label:dog': 'van je hond',
  'ai-weight-analyzer:pet-label:cat': 'van je kat',
  'ai-weight-analyzer:entry:cdp-tile:title:with-name':
    'Is het gewicht van {petName} oké? Check het in 30 sec.',
  'ai-weight-analyzer:entry:cdp-tile:title': 'Is het gewicht {petLabel} oké? Check het in 30 sec.',
  'ai-weight-analyzer:entry:cdp-tile:cta': 'Nu checken',
  'ai-weight-analyzer:entry:pet-profile:title:with-name':
    'Klopt het gewicht van {petName}? Laat het checken met een foto.',
  'ai-weight-analyzer:entry:pet-profile:title':
    'Klopt het gewicht {petLabel}? Laat het checken met een foto.',
  'ai-weight-analyzer:entry:pet-profile:cta': 'Nu controleren',
  'ai-weight-analyzer:overlay:close': 'Sluiten',
  'ai-weight-analyzer:overlay:title': 'AI-gewichtsanalyse',
  'landingpage:segmentation-pulldown:sub-title': 'Waarmee kunnen we helpen?',
  'landingpage:segmentation-pulldown:intolerance': 'Mijn hond heeft <b>intoleranties</b>',
  'landingpage:segmentation-pulldown:pickyeater': 'Mijn hond is <b>erg kieskeurig</b>',
  'landingpage:segmentation-pulldown:digestion': 'Mijn hond heeft <b>spijsverteringsproblemen</b>',
  'landingpage:segmentation-pulldown:skin-fur': 'Mijn hond heeft <b>huid- & vachtproblemen</b>',
  'landingpage:segmentation-pulldown:welpe': 'Mijn hond is <b>een puppy (0-1 jaar)</b>',
  'landingpage:segmentation-pulldown:senior': 'Mijn hond is <b>een senior (8+ jaar)</b>',
  'landingpage:segmentation-pulldown:overweight': 'Mijn hond heeft <b>overgewicht</b>',
  'landingpage:segmentation-pulldown:foodaid': 'Niet zeker? Laat je nu adviseren',
  'landingpage:segmentation-pulldown:no-help-needed': '... heeft geen bijzondere behoeften',
  'landingpage:segmentation-pulldown:pickyeatercat': 'Mijn kat is <b>kieskeurig</b>',
  'landingpage:segmentation-pulldown:digestioncat':
    'Mijn kat heeft <b>spijsverteringsproblemen</b>',
  'landingpage:segmentation-pulldown:overweightcat': 'Mijn kat heeft <b>overgewicht</b>',
  'landingpage:segmentation-pulldown:sterilized': 'Mijn kat is <b>gesteriliseerd</b>',
  'landingpage:segmentation-pulldown:outdoor': 'Mijn kat is een <b>buitenkat</b>',
  'landingpage:segmentation-pulldown:kitten': 'Mijn kat is een <b>kitten (0-1 jaar)</b>',
  'landingpage:segmentation-pulldown:seniorcat': 'Mijn kat is een <b>senior (10+ jaar)</b>',
  [`landingpage:segmentation-pulldown:${SegmentationIds.IntoleranceCat}`]:
    'Mijn kat heeft <b>intoleranties</b>',
  [`landingpage:segmentation-pulldown:${SegmentationIds.SkinFurCat}`]:
    'Mijn kat heeft <b>vacht- of huidproblemen</b>',

  'landingpage:slider-selection-pickyeater': 'Kieskeurig',
  'landingpage:slider-selection-digestion': 'Spijsverteringsproblemen',
  'landingpage:slider-selection-intolerance': 'Intoleranties',
  'landingpage:slider-selection-prevention': 'Gezondheidspreventie',
  'landingpage:slider-selection-skin-fur': 'Huid- & vachtproblemen',
  'landingpage:slider-selection-overweight': 'Overgewicht',
  'landingpage:slider-selection-junior': 'Puppy',
  'landingpage:slider-selection-kitten': 'Kitten',
  'landingpage:slider-selection-senior': 'Senior',

  'landingpage:nutrition-needs-guidance:last-slide-redirect': 'Meer passende producten',
  'landingpage:influencer-slider:title': 'De favorieten van #{name}',
  'landingpage:influencer-slider:cta-button': 'Meer producten',

  'landingpage:special-and-limited-editions-slider:title': 'Onze highlights',
  'landingpage:last-slider-CTA-Snacks': 'Ontdek onze snacks',
  'landingpage:last-slider-CTA-Zubehör': 'Ontdek onze accessoires',
  'landingpage:last-slider-CTA-Gesundheit': 'Gezondheid voor honden',
  'landingpage:last-slider-CTA-Pflege': 'Ontdek onze verzorgingsproducten',
  'landingpage:last-slider-CTA-default': 'Ontdek onze andere producten',

  [`landingpage:breed-slider:breed:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`landingpage:breed-slider:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`landingpage:breed-slider:breed:${SegmentationIds.Dachshund}`]: 'Teckel',
  [`landingpage:breed-slider:breed:${SegmentationIds.Havanese}`]: 'Maltezer',
  [`landingpage:breed-slider:breed:${SegmentationIds.Poodle}`]: 'Poedel',
  [`landingpage:breed-slider:breed:${SegmentationIds.Retriever}`]: 'Retriever',
  [`landingpage:breed-slider:breed:${SegmentationIds.ShepherdDog}`]: 'Herdershond',
  [`landingpage:breed-slider:breed:${SegmentationIds.Spitz}`]: 'Spits',
  [`landingpage:breed-slider:breed:${SegmentationIds.Terrier}`]: 'Terriër',
  [`landingpage:breed-slider:breed:${SegmentationIds.Herdingdog}`]: 'Herdershond',
  [`landingpage:breed-slider:breed:${SegmentationIds.MixedSmall}`]: 'Kruising - klein',
  [`landingpage:breed-slider:breed:${SegmentationIds.MixedLarge}`]: 'Kruising - groot',

  'landingpage:problem-solver:description':
    'De juiste voeding vinden kan behoorlijk frustrerend zijn. Elke hond is tenslotte uniek - met eigen problemen en behoeften! Wij hebben ons ten doel gesteld om voor elke behoefte de passende receptuur te ontwikkelen.',
  'landingpage:problem-solver-cat:description':
    'De juiste voeding vinden kan behoorlijk frustrerend zijn.Elke kat is tenslotte uniek - met eigen problemen en behoeften! Wij hebben ons ten doel gesteld om voor elke behoefte de passende receptuur te ontwikkelen.',

  'landingpage:nutrition-usps:grains': 'Zonder granen{br}& suiker',
  'landingpage:nutrition-usps:meat': 'Vers{br}vlees',
  'landingpage:nutrition-usps:additives': 'Vrij van aroma-,{br}kleur- & vulstoffen',
  'landingpage:nutrition-usps:texture': 'Aantrekkelijke{br}structuur & geur',
  'landingpage:nutrition-usps:fruits': 'Vers fruit{br}& groente',
  'landingpage:nutrition-usps:gentle': 'Zacht{br}verwerkt',

  'landingpage:problem-solver:sub-headline':
    'Uiteraard onder de hoogste Pets Deli kwaliteitsnormen:',
  'landingpage:problem-solver:cta': 'Meer over Pets Deli informatie',

  'landingpage:greeting': 'LEUK Je Weer Te Zien!',

  'landingpage:ad-tile:cta-button:pickyeater': 'Voeding voor kieskeurige eters',
  'landingpage:ad-tile:cta-button:intolerance': 'Voeding voor honden met allergieën',
  'landingpage:ad-tile:cta-button:skin-fur': 'Voeding voor sterke huid & vacht',
  'landingpage:ad-tile:cta-button:digestion': 'Voeding voor honden met gevoelige spijsvertering',
  'landingpage:ad-tile:cta-button:overweight': 'Voeding voor een slanke lijn',
  'landingpage:ad-tile:cta-button:senior': 'Voeding voor oudere honden',
  'landingpage:ad-tile:cta-button:welpe': "Voeding voor puppy's",
  'landingpage:ad-tile:cta-button:bulldog': 'Voeding voor bulldogs',
  'landingpage:ad-tile:cta-button:chihuahua': "Voeding voor chihuahua's",
  'landingpage:ad-tile:cta-button:dachshund': 'Voeding voor teckels',
  'landingpage:ad-tile:cta-button:havanese': 'Voeding voor maltezers',
  'landingpage:ad-tile:cta-button:herdingdog': 'Voeding voor herdershonden',
  'landingpage:ad-tile:cta-button:poodle': 'Voeding voor poedels',
  'landingpage:ad-tile:cta-button:retriever': 'Voeding voor retrievers',
  'landingpage:ad-tile:cta-button:shepherd-dog': 'Voeding voor herdershonden',
  'landingpage:ad-tile:cta-button:spitz': 'Voeding voor spitsen',
  'landingpage:ad-tile:cta-button:terrier': 'Voeding voor terriërs',
  'landingpage:ad-tile:cta-button:pickyeatercat': 'Voeding voor kieskeurige eters',
  'landingpage:ad-tile:cta-button:seniorcat': 'Voeding voor oudere katten',
  'landingpage:ad-tile:cta-button:kitten': 'Voeding voor kittens',
  'landingpage:ad-tile:cta-button:digestioncat': 'Voeding voor katten met gevoelige spijsvertering',
  'landingpage:ad-tile:cta-button:overweightcat': 'Voeding voor een slanke lijn',
  'landingpage:ad-tile:cta-button:outdoor': 'Voeding voor buitenkatten',
  'landingpage:ad-tile:cta-button:sterilized': 'Voeding voor gesteriliseerde katten',

  'landingpage:ad-tile:cta-button:set-new-option': 'Of pas je behoefte aan',

  'landingpage:bestseller-slider:title:dogs': 'Populair bij honden',
  'landingpage:bestseller-slider:title:cats': 'Populair bij poesjes',
  'landingpage:bestseller-slider:title-profile-no-name:dogs': 'Aanbevolen voor je hond',
  'landingpage:bestseller-slider:title-profile-no-name:cats': 'Aanbevolen voor je kat',

  'landingpage:bestseller-slider:title-profile-with-name': 'Perfect voor {petName}',

  'landingpage:home:home:title': 'Gezond begint \nin de voerbak!',
  'landingpage:home:home:sub-title': 'Voor wie zoek je de <span>perfecte voeding?</span>',

  'landingpage:home:sub-headline': 'Wij vinden de perfecte voeding voor jullie!',
  'landingpage:home:cta-button': 'Behoefte kiezen...',
  'landingpage:home:breed-selector:headline': 'Of kies een ras',

  'landingpage:home:global-rating-values': '{rating} ({count} productbeoordelingen)',

  'landingpage:home:slider:headline': 'Individuele behoeften. Individuele recepturen.',

  'landingpage:home:fube-entry:headline': 'Voor de moeilijkere gevallen Digitale voedingsadviseur',
  'landingpage:home:fube-entry:image-alt': 'Precies voor mij',
  'landingpage:home:fube-entry:usp-1':
    'Heeft al <span>12.567</span> klanten geholpen bij het zoeken naar voeding',
  'landingpage:home:fube-entry:usp-2:dog':
    'Beantwoord 7 vragen. Wij zeggen wat je <span>hond</span> nodig heeft.',
  'landingpage:home:fube-entry:usp-2:cat':
    'Beantwoord 7 vragen. Wij zeggen je wat <span>je poes</span> nodig heeft',

  'landingpage:home:dog-cat:slider:headline':
    'Probeerpakketten met kennismakingskorting & gratis voedingsgids',
  'landingpage:standalone-cdp:headline': 'Ontdek onze verscheidenheid',
  'landingpage:standalone-cdp:ec-dog:sub-headline': 'Probeer gewoon eens gezond',
  'landingpage:standalone-cdp:nc-cat:sub-headline': 'Probeer gewoon eens gezond',
  'landingpage:standalone-cdp:nc-dog:sub-headline': 'Probeer gewoon eens gezond',
  'landingpage:standalone-cdp:home:sub-headline': 'Individuele behoeften. Individuele recepturen.',

  'landingpage:need-capture:which-need-most-applied':
    'Welke behoefte is het <b>MEEST</b> van toepassing?',
  'landingpage:need-capture:which-need-most-applied-dog':
    'Vertel ons daarbij welke behoefte het <b>MEEST</b> op je hond van toepassing is <b>OF</b> kies een ras:{br} <a>Wanneer kies ik liever een behoefte? Wanneer kies ik liever een ras?</a>',
  'landingpage:need-capture:which-need-most-applied-cat':
    'Vertel ons daarbij welke behoefte het<b> MEEST </b> op je kat van toepassing is',
  'landingpage:need-capture:title': 'Lievelingsvoeding.{br} precies voor jou!',
  'landingpage:need-capture:sub-title:dog':
    'Gezond begint in de voerbak. Precies volgens dit motto helpen we je de perfecte voeding voor je hond te vinden!',
  'landingpage:need-capture:sub-title:cat':
    'Gezond begint in de voerbak. Precies volgens dit motto helpen we je de perfecte voeding voor je fluweelpootje(s) te vinden!',
  'landingpage:need-capture:date-of-birth:month:label': 'Geboortemaand',
  'landingpage:need-capture:date-of-birth:month:placeholder': 'MM',
  'landingpage:need-capture:date-of-birth:year:label': 'Geboortejaar',
  'landingpage:need-capture:date-of-birth:year:placeholder': 'JJJJ',
  'landingpage:need-capture:date-of-birth:text:dog':
    '<row><label>Mijn hond is in</label>{dateOfBirth}</row>' +
    '<row><label>geboren, is een</label>{breed}</row>' +
    '<row><label>heeft</label>{needs}</row>' +
    '<row><label>en heeft een voorkeur voor</label>{food}</row>',
  'landingpage:need-capture:date-of-birth:text:cat':
    '<row><label>Mijn kat is in</label>{dateOfBirth}</row>' +
    '<row><label>geboren, heeft</label>{needs}</row>' +
    '<row><label>en eet het liefst</label>{food}</row>',
  'landingpage:need-capture:age:text:dog': 'Mijn hond is een',
  'landingpage:need-capture:age:text:cat': 'Mijn kat is',
  'landingpage:need-capture:age:text:cat:separator': 'heeft',
  'landingpage:need-capture:age:text:cat:separator-2': 'en heeft het liefst',
  'landingpage:need-capture:age:text:cat:separator-3': 'het liefst',
  'landingpage:need-capture:age:text:cat:separator-4': 'en',
  'landingpage:need-capture:age:text:cat:separator-5': 'heeft het allerliefst',
  'landingpage:need-capture:age:placeholder': 'Leeftijd',
  'landingpage:need-capture:breed:placeholder': 'Ras',
  'landingpage:need-capture:breed:text': 'en heeft',
  'landingpage:need-capture:needs:placeholder': 'De volgende behoefte',
  'landingpage:need-capture:food-type-and-taste:placeholder': 'Voedingssoort & smaak',
  'landingpage:need-capture:dog-food-type:placeholder': 'Voedingssoort',
  'landingpage:need-capture:dog-food-type:text:mobile': 'en heeft voorkeur voor',
  'landingpage:need-capture:dog-food-type:text:desktop:above': 'en',
  'landingpage:need-capture:dog-food-type:text:desktop:inline': 'heeft voorkeur voor',
  'landingpage:need-capture:needs:text:desktop': 'heeft',

  [`landingpage:need-capture:age:${SegmentationIds.Welpe}`]: 'Junior',
  [`landingpage:need-capture:age:${SegmentationIds.DogAdult}`]: 'Adult',
  [`landingpage:need-capture:age:${SegmentationIds.DogSenior}`]: 'Senior',
  [`landingpage:need-capture:age:${SegmentationIds.Kitten}`]: 'Kitten (0-1 jaar)',
  [`landingpage:need-capture:age:${SegmentationIds.CatAdult}`]: 'Adult (1-10 jaar)',
  [`landingpage:need-capture:age:${SegmentationIds.CatSenior}`]: 'Senior (10+ jaar)',
  [`landingpage:need-capture:breed:${SegmentationIds.Bulldog}`]: 'Bulldog',
  [`landingpage:need-capture:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`landingpage:need-capture:breed:${SegmentationIds.Dachshund}`]: 'Teckel',
  [`landingpage:need-capture:breed:${SegmentationIds.Havanese}`]: 'Havanezer',
  [`landingpage:need-capture:breed:${SegmentationIds.Poodle}`]: 'Poedel',
  [`landingpage:need-capture:breed:${SegmentationIds.Retriever}`]: 'Retriever',
  [`landingpage:need-capture:breed:${SegmentationIds.ShepherdDog}`]: 'Herdershond',
  [`landingpage:need-capture:breed:${SegmentationIds.Spitz}`]: 'Spits',
  [`landingpage:need-capture:breed:${SegmentationIds.Terrier}`]: 'Terriër',
  [`landingpage:need-capture:breed:${SegmentationIds.Herdingdog}`]: 'Herdershond',
  [`landingpage:need-capture:breed:${SegmentationIds.MixedSmall}`]: 'Kruising (klein)',
  [`landingpage:need-capture:breed:${SegmentationIds.MixedLarge}`]: 'Kruising (groot)',
  [`landingpage:need-capture:breed:${SegmentationIds.OtherBreed}`]: 'Ander ras',

  'landingpage:need-capture:selector': 'Kies alsjeblieft maximaal 2 speciale behoeften:',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.PickyEater}`]:
    'Kieskeurige eter',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Digestion}`]:
    'Spijsverteringsproblemen',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.SkinFur}`]:
    'Huid- & vachtproblemen',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Intolerance}`]: 'Intoleranties',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Overweight}`]: 'Overgewicht',
  [`landingpage:need-capture:need:selector:option:${SegmentationIds.Prevention}`]:
    'Gezondheidspreventie',
  [`landingpage:need-capture:need:selector:cta:confirm`]: 'Opslaan',
  [`landingpage:need-capture:need:option:${SegmentationIds.PickyEater}`]: 'Kieskeurig eetgedrag',
  [`landingpage:need-capture:need:option:${SegmentationIds.Digestion}`]: 'Spijsverteringsproblemen',
  [`landingpage:need-capture:need:option:${SegmentationIds.SkinFur}`]: 'Huid- & vachtproblemen',
  [`landingpage:need-capture:need:option:${SegmentationIds.Intolerance}`]: 'Intoleranties',
  [`landingpage:need-capture:need:option:${SegmentationIds.Overweight}`]: 'Overgewicht',
  [`landingpage:need-capture:need:option:${SegmentationIds.Prevention}`]: 'Gezondheidspreventie',
  'landingpage:need-capture:heroImage:description':
    'Afbeelding van een huisdier in het heldengedeelte',
  'landingpage:need-capture:products-list:title': '  Deze bestsellers passen precies bij jullie:',
  'landingpage:need-capture:products-list:default-cat-title': 'Onze bestsellers voor katten',
  'landingpage:need-capture:products-list:cta': 'Alle producten weergeven →',
  'empty-product-list:text:dog':
    'Vertel ons hierboven meer over je hond en we tonen je hier passende aanbevelingen.',
  'empty-product-list:text:cat':
    'Vertel ons hierboven meer over je kat en we tonen je hier passende aanbevelingen.',
  'landingpage:about-us-modal:headline':
    'Hoi! Wij zijn Pets Deli en maken voeding die echt wat kan.',
  'landingpage:about-us-modal:section:1':
    '<b>Wat dat betekent: </b> Wij weten dat voeding individueel moet zijn. Want elke viervoeter heeft andere behoeften. Of het nu gaat om een puppy, senior, ziektes, allergieën of een slechte eter - standaardvoeding past in de weinigste gevallen. Want bij gewone voeding wordt meestal weinig waarde gehecht aan hoogwaardige ingrediënten of de samenstelling. Het bestaat vaak uit een zeer groot aandeel granen of andere goedkope vulstoffen, een zeer laag vleesgehalte en smaakversterkers, suiker en moeilijk verteerbare afvalstoffen van de levensmiddelenindustrie zoals klauwen, veren of hoeven. Dat klinkt niet alleen smerig, maar is ook voedingsfysiologisch gezien niet het beste wat je je viervoeter kunt bieden.',
  'landingpage:about-us-modal:section:2':
    "<b>Wij doen dat anders: </b> Met onze producten spelen we specifiek in op de individuele voedingsbehoeften van je viervoeter. Wij bieden op maat gemaakte menu's die dankzij hun uitgekiende recepturen helpen om een groot deel van alle voedingsproblemen op te lossen. Daarvoor investeren wij veel tijd in de productontwikkeling: onze dierenartsen werken op basis van de nieuwste voedingswetenschappen en zorgen steeds voor een diervriendelijke, hoogwaardige en smaakvolle samenstelling.",
  'landingpage:about-us-modal:section:3:dogs':
    '<b>Onze belofte: </b> Wij hechten daarbij bijzondere waarde aan de kwaliteit van onze grondstoffen, een zachte verwerking en de samenstelling van onze producten. Uiteraard laten we ook klantfeedback meewegen in onze productontwikkelingen en breiden we ons aanbod voortdurend uit. Wat komt daaruit? Een breed productassortiment voor de meest uiteenlopende behoeften: heerlijk natvoer, volwaardig droogvoer, vers BARF, vleesloze alternatieven en een hoop functionele, gezonde en lekkere snacks. Daarbij zorgen verse ingrediënten, zoals echt vlees, vitaminerijke fruit- & groentesoorten en waardevolle oliën en mineralen voor de eersteklas Pets Deli smaak en ondersteunen ze niet alleen de gezondheid, maar ook de levenskwaliteit van je hond.',
  'landingpage:about-us-modal:section:3:cats':
    '<b>Onze belofte: </b> Wij hechten daarbij bijzondere waarde aan de kwaliteit van onze grondstoffen, een zachte verwerking en de samenstelling van onze producten. Uiteraard laten we ook klantfeedback meewegen in onze productontwikkelingen en breiden we ons aanbod voortdurend uit. Wat komt daaruit? Een breed productassortiment voor de meest uiteenlopende behoeften: heerlijk natvoer, volwaardig droogvoer en een hoop functionele, gezonde en lekkere snacks. Daarbij zorgen verse ingrediënten, zoals echt vlees, vitaminerijke fruit- & groentesoorten en waardevolle oliën en mineralen voor de eersteklas Pets Deli smaak en ondersteunen ze niet alleen de gezondheid, maar ook de levenskwaliteit van je poes.',

  'landingpage:home:fte-segmentation:dog:info-text':
    'Om de perfecte voeding te vinden, vertel ons welke behoefte {br} het meest op je hond van toepassing is of kies het passende ras:',
  'landingpage:home:fte-segmentation:cat:info-text':
    '   Vertel ons daarbij welke behoefte het<b> MEEST </b> op je kat van toepassing is',
  [`landingpage:need-capture:age:${SegmentationIds.Kitten}`]: 'Kitten',
  [`landingpage:need-capture:age:${SegmentationIds.CatAdult}`]: 'Adult',
  [`landingpage:need-capture:age:${SegmentationIds.CatSenior}`]: 'Senior',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatPickyEater}`]:
    'een kieskeurig eetgedrag',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatDigestion}`]:
    'Spijsverteringsproblemen',
  [`landingpage:need-capture:need:option:${SegmentationIds.CatOverweight}`]: 'Overgewicht',
  [`landingpage:need-capture:need:option:${SegmentationIds.IntoleranceCat}`]:
    'Allergieën & intoleranties',
  [`landingpage:need-capture:need:option:${SegmentationIds.SkinFurCat}`]: 'Huid- & vachtproblemen',
  [`landingpage:need-capture:need:option:${SegmentationIds.HairballHelp}`]: 'Haarbal-hulp',
  [`landingpage:need-capture:need:option:${SegmentationIds.ImmuneSystem}`]:
    'een verzwakt immuunsysteem',

  // Picky Cats engagement test — registered here so the app IntlProvider serves the
  // module-local picky-cats:* ids; the funnel/entry-point read these via formatMessage.
  'picky-cats:question:bowl-shape:prompt': 'Uit wat voor voerbak eet je kat?',
  'picky-cats:question:bowl-shape:option:deep-narrow': 'Diep & smal',
  'picky-cats:question:bowl-shape:option:wide-shallow': 'Ondiep & breed',
  'picky-cats:question:bowl-shape:option:not-sure': 'Weet ik niet zeker',
  'picky-cats:question:bowl-location:prompt': 'Waar staat de voerbak?',
  'picky-cats:question:bowl-location:option:near-litter': 'Bij de kattenbak / prullenbak',
  'picky-cats:question:bowl-location:option:busy-spot': 'Op een drukke plek',
  'picky-cats:question:bowl-location:option:quiet-spot': 'Op een rustige, ontspannen plek',
  'picky-cats:question:feeding-frequency:prompt': 'Hoe vaak eet je kat per dag?',
  'picky-cats:question:feeding-frequency:option:once': '1× per dag',
  'picky-cats:question:feeding-frequency:option:twice-plus': '2 of meer maaltijden',
  'picky-cats:question:feeding-frequency:option:free-feed': 'Altijd beschikbaar',
  'picky-cats:question:feed-temperature:prompt': 'Hoe serveer je het voer?',
  'picky-cats:question:feed-temperature:option:cold': 'Rechtstreeks uit de koelkast',
  'picky-cats:question:feed-temperature:option:room-temp': 'Op kamertemperatuur',
  'picky-cats:question:feed-temperature:option:warmed': 'Licht opgewarmd',
  'picky-cats:question:multi-cat:prompt': 'Wonen er nog andere katten in huis?',
  'picky-cats:question:multi-cat:option:solo': 'Alleen deze kat',
  'picky-cats:question:multi-cat:option:shared-bowl': 'Ja, met een gedeelde voerbak',
  'picky-cats:question:multi-cat:option:separate-bowls': 'Ja, met eigen voerbakken',
  'picky-cats:cta:next': 'Verder',
  'picky-cats:cta:see-all': 'Alles bekijken',
  'picky-cats:cta:browse-collection': 'Voeding voor kieskeurige katten bekijken',
  'picky-cats:a11y:back': 'Terug',
  'picky-cats:entry:engagement:eyebrow': 'Kattenkennis',
  'picky-cats:entry:engagement:headline': 'Misschien is je kat helemaal niet kieskeurig',
  'picky-cats:entry:engagement:subtitle':
    'Vaak gaat het om hoe we voeren, niet om wat. Ontdek waar het echt aan ligt.',
  'picky-cats:entry:engagement:cta': 'Ontdek het nu',
  'picky-cats:entry:engagement:v2:headline': 'De vorm van de voerbak maakt het verschil',
  'picky-cats:entry:engagement:v2:subtitle':
    'En nog een paar kleine trucs waar de meeste baasjes nooit van horen.',
  'picky-cats:entry:engagement:v2:cta': 'Bekijk hoe jij je kat voert',
  'picky-cats:floating:label': 'Kieskeurige kat?',
  'picky-cats:tip:bowl:text':
    'Kies een ondiepe, brede voerbak, zodat de snorharen de rand niet raken.',
  'picky-cats:tip:location:text':
    'Zet de voerbak uit de buurt van de kattenbak en drukke looproutes.',
  'picky-cats:tip:temperature:text':
    'Serveer het voer op kamertemperatuur, zodat het aroma goed tot zijn recht komt.',
  'picky-cats:result:recommendation-heading': 'Aanbeveling voor jou',
  'picky-cats:result:tips-title': 'Dit kan je kat helpen',
  'picky-cats:result:tips-subtitle':
    'Kleine aanpassingen met een groot effect – plus passende producten.',
};
